var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#E6321E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 30.4325C56 29.6459 55.3271 29 54.5074 29H29.4926C28.6729 29 28 29.6459 28 30.4325V49.3906C28 50.1773 28.6729 50.8231 29.4926 50.8231H31.4911C32.3108 50.8231 32.9837 51.469 32.9837 52.2557V57.2526C32.9837 58.0392 33.4695 58.2383 34.0614 57.6896L40.4163 51.8138C41.0083 51.265 42.1619 50.8183 42.9866 50.8183H54.5074C55.3271 50.8183 56 50.1724 56 49.3857V30.4325Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9933 42.06C42.9793 41.976 42.9793 41.906 42.9793 41.878C42.9793 41.332 43.2173 40.87 43.6793 40.548L44.2813 40.128C45.0933 39.554 45.6813 38.77 45.6813 37.664C45.6813 36.236 44.5613 34.864 42.4893 34.864C40.3753 34.864 39.3253 36.39 39.3253 37.79C39.3253 38.014 39.3533 38.238 39.4093 38.434L40.9913 38.546C40.9353 38.392 40.9073 38.126 40.9073 37.916C40.9073 37.118 41.4533 36.32 42.4893 36.32C43.5113 36.32 44.0013 37.006 44.0013 37.734C44.0013 38.21 43.8053 38.616 43.3433 38.952L42.6993 39.414C41.8873 40.002 41.5653 40.688 41.5653 41.528C41.5653 41.724 41.5793 41.878 41.5933 42.06H42.9933ZM41.2853 44.076C41.2853 44.636 41.7333 45.098 42.3073 45.098C42.8673 45.098 43.3293 44.636 43.3293 44.076C43.3293 43.516 42.8673 43.04 42.3073 43.04C41.7333 43.04 41.2853 43.516 41.2853 44.076Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.298bda56d053584f3e44c8fbd8eac2cf.svg";
export { ForwardRef as ReactComponent };